// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#hipay-hostedfields-form{border-radius:4px;margin-bottom:16px}#hipay-hostedfields-form .hipay-form-container{max-width:none}#hipay-hostedfields-form .hipay-field-container{margin:8px}#hipay-hostedfields-form .hipay input{font-size:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
